module.exports = __webpack_public_path__ + "static/media/30_B.b07970af.png";